import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  // MobileStepper,
  // Paper,
  Snackbar,
  Typography,
  Card,
  Divider,
  // TextField,
  // MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  // Button,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

// import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
import AppConfig from "appConfig";
import MDButton from "theme/components/MDButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { toPng } from "html-to-image";
import QRCode from "react-qr-code";
import MDTypography from "theme/components/MDTypography";

function ProductDetailPage() {
  const [pageTitle, setPageTitle] = useState("Sell Product");
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const qrCodeRef = useRef(null);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  // const [productReference, setProductReference] = useState(null);
  // const [campaign, setCampaign] = useState({});
  // const [webstore, setWebstore] = useState({});
  const [productName, setProductName] = useState(null);
  const [productDescription, setProductDescription] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [productPrice, setProductPrice] = useState(0.0);
  const [productCurrency, setProductCurrency] = useState(null);
  const [productCommission, setProductCommission] = useState(null);
  const [productLink, setProductLink] = useState(null);

  const [index, setActiveStep] = useState(0);
  const [productImageSize, setProductImageSize] = useState(0);

  // Function to go to the next picture
  const goToNextPicture = () => {
    if (index === productImageSize - 1) {
      setActiveStep(0);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const goBackToPicture = () => {
    if (index === 0) {
      setActiveStep(productImageSize - 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/hustle/products/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            // setCampaign(result.data.data.product.campaign);
            // setProductReference(result.data.data.product.reference);
            setProductName(result.data.data.product.title);
            setProductDescription(result.data.data.product.description);
            setProductImages(result.data.data.product.images);
            setProductLink(result.data.data.link);
            // setProductVariants(result.data.data.product.variants);
            setProductPrice(result.data.data.product.price);
            setProductImageSize(result.data.data.product.images.length);
            setProductCurrency(result.data.data.product.currency);
            setProductCommission(result.data.data.commission);

            setPageTitle(`Laddar Africa | ${result.data.data.product.title}`);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function copy() {
    const stringtext = productLink;
    try {
      await navigator.clipboard.writeText(stringtext);
      setErrMsg("Link copied!");
      setSeverity("success");
      setOpen(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  function shareLink(platform) {
    const link = productLink;
    let msg = `${
      productPrice !== null && productPrice
        ? `%0a*${productCurrency}${(productPrice / 100).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}*%0a`
        : ""
    }`;
    msg = `${encodeURIComponent(productName)}.${msg}%0a*Buy Now*%0a${encodeURIComponent(link)}`;
    let url = "";
    if (platform === "whatsapp") {
      url = `whatsapp://send?text=${msg}`;
    } else {
      url = `https://t.me/share/url?url=${msg}`;
    }
    window.open(url, "_blank");
  }

  const [selectedLink, setSelectedLink] = useState(null);
  const [openQRCodeDialog, setOpenQRCodeDialog] = useState(false);

  function downloadQRCode() {
    toPng(qrCodeRef.current)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${productName}.png`;
        link.click();
      })
      .catch((error) => {
        console.error("Error generating QR code:", error);
      });
  }

  async function webShare(title, text, url, imageUrl = null) {
    if (navigator.share === "undefined") {
      alert("Your browser does not support this feature.");
      return;
    }

    imageUrl = null;
    let shareObject = {};
    if (imageUrl !== null) {
      setShowLoading(true);
      try {
        const image = await fetch(imageUrl, { cache: "no-cache" });
        const blobData = await image.blob();
        const fileObj = new File([blobData], `product.jpg`, { type: blobData.type });

        // shareObject.files = [fileObj];
        shareObject = {
          title: `${title}`,
          text: `${text}`,
          files: [fileObj],
          url: `${url}`,
        };
        setShowLoading(false);
      } catch (error) {
        setShowLoading(false);
        shareObject = {
          title: `${title}`,
          text: `${text}`,
          url: `${url}`,
        };
      }
    } else {
      shareObject = {
        title: `${title}`,
        text: `${text}`,
        url: `${url}`,
      };
    }

    try {
      navigator
        .share(shareObject)
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch((err) => {
          // Handle errors, if occurred
          console.log("Error while using Web share API:");
          console.log(err);
        });
    } catch (err) {
      console.error("Share failed:", err.message);
      alert("Your browser does not support this feature.");
    }
  }

  function shareWebProduct() {
    const plink = productLink;
    const msg = `Buy ${productName} ${
      productPrice !== null && productPrice
        ? `at ${productCurrency}${(productPrice / 100).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : ""
    }. Click the link for more info.`;

    const imageUrl = `${AppConfig.api_cors_url}media/${productImages[index]}`;
    webShare(productName, msg, plink, imageUrl);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {selectedLink ? (
        <Dialog open={openQRCodeDialog}>
          <DialogTitle>
            <MDBox>QR Code</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox p={2} ref={qrCodeRef}>
              <QRCode value={selectedLink} size={180} />
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenQRCodeDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                close
              </Icon>
            </MDButton>
            <MDButton
              onClick={() => downloadQRCode()}
              color="success"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                download
              </Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      <Box mt={{ xs: 1, md: 3, lg: 3 }} mb={5}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={6}>
            <Box p={3} align="center">
              <Box sx={{ width: 1 }}>
                <img
                  // src="https://placehold.co/600x400.png"
                  src={`${AppConfig.api_media_url}${productImages[index]}`}
                  alt="img"
                  width="80%"
                />
              </Box>
              {productImageSize > 1 ? (
                <Box mt={2}>
                  <Grid container spacing={3}>
                    <Grid item xs={6} md={6} lg={6}>
                      <Box>
                        <MDButton
                          size="small"
                          iconOnly
                          // circular
                          color="primary"
                          onClick={goBackToPicture}
                          variant="outlined"
                        >
                          <Icon>chevron_left</Icon>
                        </MDButton>
                      </Box>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Box>
                        <MDButton
                          size="small"
                          iconOnly
                          // circular
                          color="primary"
                          variant="outlined"
                          onClick={goToNextPicture}
                        >
                          <Icon>chevron_right</Icon>
                        </MDButton>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <> </>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Card sx={{ height: "100%" }} elevation={2}>
              <Box p={2} sx={{ height: "100%" }}>
                <Box mb={0}>
                  <Typography variant="h6" fontWeight={100} mt={0}>
                    {productName}
                  </Typography>
                  {productPrice !== null && productPrice > 0 ? (
                    <Typography variant="h4" fontWeight={600} color="text">
                      <small>{productCurrency}</small>
                      {(productPrice / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  ) : (
                    <> </>
                  )}
                </Box>
                <Box mb={3}>
                  <MDTypography variant="caption">
                    Commission: <b>{productCommission}</b>
                  </MDTypography>
                </Box>
                <MDBox
                  ml={-1}
                  mt={0}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="start"
                >
                  <a href={productLink} target="_blank" rel="noreferrer">
                    <IconButton variant="outlined" color="dark">
                      <Icon>send</Icon>
                    </IconButton>
                  </a>
                  <IconButton variant="outlined" color="primary" onClick={() => copy()}>
                    <Icon>copy</Icon>
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setSelectedLink(productLink);
                      setOpenQRCodeDialog(true);
                    }}
                    color="info"
                  >
                    <Icon>qr_code</Icon>
                  </IconButton>
                  <IconButton onClick={() => shareLink("whatsapp")}>
                    <WhatsAppIcon color="success">WhatsApp</WhatsAppIcon>
                  </IconButton>
                  <IconButton onClick={() => shareLink("telegram")}>
                    <Icon color="info">telegram</Icon>
                  </IconButton>
                  <IconButton onClick={() => shareWebProduct()}>
                    <Icon color="dark">share</Icon>
                  </IconButton>
                </MDBox>
                <Divider />
                <Box my={3}>
                  <Typography variant="caption" fontWeight={500}>
                    Description
                  </Typography>
                  <Box mt={1}>
                    <Typography variant="caption" fontWeight={100} mt={3}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: productDescription,
                        }}
                      />
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Box mb={10}>&nbsp;</Box>
      <Footer />
    </DashboardLayout>
  );
}

export default ProductDetailPage;
